import { render, staticRenderFns } from "./explain-search-box-base.component.vue?vue&type=template&id=0fd41661&scoped=true"
import script from "./explain-search-box-base.component.vue?vue&type=script&lang=ts"
export * from "./explain-search-box-base.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-search-box-base.component.vue?vue&type=style&index=0&id=0fd41661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd41661",
  null
  
)

export default component.exports